import { render, staticRenderFns } from "./CurrencyField.vue?vue&type=template&id=6cf336c8&"
import script from "./CurrencyField.vue?vue&type=script&lang=ts&"
export * from "./CurrencyField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports